import { Routes } from '@angular/router';
import { isAuthenticatedGuard } from './core/auth/is-authenticated.guard';
import { UnauthenticatedComponent } from './core/auth/unauthenticated.component';

export const routes: Routes = [
  {
    path: 'unauthenticated',
    component: UnauthenticatedComponent
  },
  {
    path: '',
    loadComponent: () => import('./modules/start/start.component').then(m => m.StartComponent),
    canActivate: [isAuthenticatedGuard]
  },
  {
    canActivate: [isAuthenticatedGuard],
    path: 'session/:key',
    pathMatch: "full",
    loadComponent: () => import('./modules/session/session/session.component').then(m => m.SessionComponent)
  },
  {
    canActivate: [isAuthenticatedGuard],
    path: 'session/:key/:docId',
    loadComponent: () => import('./modules/session/session/session.component').then(m => m.SessionComponent)
  },
  {
    path: "**",
    redirectTo: '',
  }
];
